import React from 'react'
import { formContent } from "./content"
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Button from "../../../../Components/Form/Button/Button";
import { useForm, FormProvider } from "react-hook-form";
import Dropdown from "../../../../Components/Form/Dropdown/Dropdown";
import MultiImageUpload from "../../../../Components/Form/MultiImageUpload/MultiImageUpload";
import BusinessDetailsApi from "../../../../Api/BusinessDetailsApi";
import SupplierProductApi from "../../../../Api/SupplierProductApi";
import {
    getApiHost,
    getProductByIdFromSession, getResponseError,
    getUserDetailsCookie,
    updateProductInSession
} from "../../../../Api/Utils/apiUtils";
import RadioGroup from "../../../../Components/Form/RadioGroup/RadioGroup";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import SuccessAlert from "../../../../Components/Form/SuccessAlert/SuccessAlert";



const ProductComponent = ({action, productId}) => {
    const {
        productName,
        description,
        category,
        productBuyType,
        priceType,
        price,
        renewalOption,
        productType,
        productImages,
        addProductButton
    } = formContent;

    let { heading } = formContent;
    let product = {};
    let productExistingImages =[];
    if(action === "update"){
        heading = "Update product";
        addProductButton.label = "Update product";
        product = getProductByIdFromSession(parseInt(productId));
        productExistingImages = product && product.GetproductInfoImage;
        productExistingImages && productExistingImages.forEach(e => {
            let imageUrl= e.imageUrl;
            if(imageUrl.indexOf('upload') === 0){
                imageUrl = getApiHost() + '/' + imageUrl;
            }
            e.imageUrl = imageUrl;
        });
    }
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [successMessage, setSuccessMessage] = React.useState(null);
    const [businessCategories, setBusinessCategories] = React.useState([]);
    const [productUploadImages, setProductUploadImages] = React.useState([]);
    const [priceTypeOptions, setPriceTypeOptions] = React.useState(priceType.options);
    const [defaultProductImages, setDefaultProductImages] = React.useState(productExistingImages);
    const [businessId, setBusinessId] = React.useState(null);

    const formBinding = useForm({defaultValues : product});
    const { watch, setValue, getValues, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));

    React.useEffect(() => {
        const getBusinessDetails = async () => {
            const user = getUserDetailsCookie();
            const userId = user.id;
            const businessDetailsResponse = await BusinessDetailsApi.getBusinessDetails(userId);
            const businessApiError = getResponseError(businessDetailsResponse);
            if(businessApiError){
                setErrorMessage(businessApiError);
            } else {
                const businessDetails =businessDetailsResponse.objectVal;
                setBusinessId(businessDetails.id);
                const categoryResponse = await BusinessDetailsApi.getCategoryKeywordList();
                const categoryApiError = getResponseError(categoryResponse);
                if(categoryApiError){
                    setErrorMessage(categoryApiError);
                } else {
                    const businessCategoryInfo = categoryResponse.objectVal.businessCategoryInfo;
                    const categoriesIds = businessDetails.category.split(",");
                    const categories = [];
                    categoriesIds.forEach(categoriesId => {
                        
                        const category = businessCategoryInfo.find(c => c.id === parseInt(categoriesId));
                        category.value = category.id;
                        category.label = category.title;
                        categories.push(category);
                    });
                    setBusinessCategories(categories);
                    setValue(category.id, categories[0].value);
                }
            }

        };
        getBusinessDetails();
    }, [category.id, setValue]);

    const updateProductPriceType =  (event) => {
        const buyType = event.target.value;
        if(buyType === 'Buy'){
            setPriceTypeOptions([]);
            setValue(priceType.id,  '');
        }else{
            const options  = [{ value: 'perDay', label: 'Per Day' },{ value: 'perHour', label: 'Per Hour' },];
            setPriceTypeOptions(options);
            if(!getValues(priceType.id)){
                setValue(priceType.id,  options[0].value);
            }
        }
    }

    const submitForm = async (data) => {
        const uploadImageFiles = [];
        productUploadImages.forEach(o => uploadImageFiles.push(o.file));
        data.imageUrl = uploadImageFiles;
        if(data.priceType === 'perHour'){
            data.isPerHour  = 1;
            data.isPerDay = 0;
        }else if(data.priceType === 'perDay'){
            data.isPerHour = 0;
            data.isPerDay = 1;
        }else {
            data.isPerHour = 0;
            data.isPerDay = 0;
        }
        data.businessId = businessId;
        data.isApplyShopTaxRate  = 1;
        data.customIsCustomization = 0;
        data.quantity = 1;
        let response;
        if(action === "update") {
            const deletedImageIds = []
            productExistingImages.forEach(img1 => {
                if(!defaultProductImages.find(img2=> img2.id === img1.id)){
                    deletedImageIds.push(img1.id)
                }
            });
            data.deleteImages = deletedImageIds.join(",");
            data.productId=productId;
            response = await SupplierProductApi.updateProduct(data);
            const apiError = getResponseError(response);
            if(apiError){
                setErrorMessage(apiError);
            } else {
                setSuccessMessage("Product updated successfully")
                const product = response.objectVal;
                product.GetproductInfoImage.forEach(img => {
                    let imageUrl = img.imageUrl;
                    if (imageUrl.indexOf('upload') === 0) {
                        imageUrl = getApiHost() + '/' + imageUrl;
                    }
                    img.imageUrl = imageUrl;
                });
                updateProductInSession(response.objectVal);
            }
        }else {
            response = await SupplierProductApi.addProduct(data);
            const apiError = getResponseError(response);
            if(apiError){
                setErrorMessage(apiError);
            } else {
                setSuccessMessage("Product added successfully")
            }
        }
    }
    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <SuccessAlert>{successMessage}</SuccessAlert>
                <FormProvider {...formBinding}>
                    <form id="login-form" onSubmit={handleSubmit(submitForm)}>
                        <TextInput {...productName} />
                        <TextInput {...description} />
                        <Dropdown {...category} options={businessCategories} />
                        <Dropdown {...productBuyType} action={updateProductPriceType}/>
                        <RadioGroup {...priceType} options={priceTypeOptions} />
                        <TextInput {...price} />
                        <RadioGroup {...renewalOption} />
                        <RadioGroup {...productType} />
                        <MultiImageUpload {...productImages}
                            defaultImages={defaultProductImages}
                            setDefaultImages={setDefaultProductImages}
                            uploadImages={productUploadImages}
                            setUploadImages={setProductUploadImages} />
                        <Button {...addProductButton}/>
                    </form>
                </FormProvider>
            </FormContainer>
        </Section>
    )
}

export default ProductComponent
